import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { RmpvPecaFiltroComponent } from './rmpv-peca-filtro/rmpv-peca-filtro.component';
import { RmpvPecaListaComponent } from './rmpv-peca-lista/rmpv-peca-lista.component';
import { RmpvPecaService } from './rmpv-peca-service/rmpv-peca.service';
import { RmpvPecaComponent } from './rmpv-peca.component';


@NgModule({
  imports: [
      HttpModule,
      FormsModule,
      CommonModule,
      BrowserModule,
      ReactiveFormsModule,
      ComumModule,
      ChartsModule,
      NgbModule,
      TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    RmpvPecaComponent
  ],
  declarations: [
    RmpvPecaComponent,
    RmpvPecaListaComponent,
    RmpvPecaFiltroComponent,
  ],
  providers: [
    RmpvPecaService,
  ]
})
export class RmpvPecaModule { }
